import React from 'react';
import { ActivityIcon, CreditCardIcon, FileTextIcon, HomeIcon, ListChecksIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
import { Button } from './ui/Button';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 min'], [ListChecksIcon, 'Paso a paso'], [ActivityIcon, 'Sin equipos'], [HomeIcon, 'Desde casa']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-175" data-mp="1274l9hahx23j">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-accent/20 blur-[120px]" data-id="element-176" data-mp="x8b6lljh351s" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-177" data-mp="nczrv382dxu1">
        <div className="mb-5 inline-flex rounded-full border border-primary/20 bg-primary/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-primary md:mb-6" data-id="element-178" data-mp="3d1ikzavvpeny">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.4rem]" data-id="element-179" data-mp="3j7zgfm2d3yi9">
          💪 Combo Completo Fortalecimiento Lumbar 2026
        </h1>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Combo Completo Fortalecimiento Lumbar 2026" data-id="element-180" data-mp="39autvl4lu10x">
          <img className="w-full max-w-[680px] object-contain drop-shadow-[0_26px_44px_rgba(29,78,216,.28)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Fortalecimiento Lumbar 2026 con sus 4 módulos y 3 bonos" data-id="element-181" data-mp="30h9d5w8vq9ov" />
        </a>

        <p className="mx-auto max-w-4xl text-xl font-black leading-tight text-primary md:text-4xl" data-id="element-182" data-mp="2vglkl6505ksj">
          Todo lo que necesitás saber para aliviar, fortalecer y proteger tu espalda. Desde hoy.
        </p>

        <p className="mx-auto mt-5 max-w-3xl text-base font-semibold leading-relaxed text-slate-600 md:text-xl" data-id="element-183" data-mp="s21kmih80q35">
          <strong className="text-ink" data-id="element-184" data-mp="nat8vfsf4smt">
            🇦🇷 EL SISTEMA COMPLETO PARA RECUPERAR TU ESPALDA EN ARGENTINA.
          </strong>{' '}
          Desde el primer dolor hasta la confianza total, todos los pasos. Ejercicios + técnicas +
          posiciones listas para hacer en casa. Sin aparatos. Sin improvisar movimientos. Sin volver
          al mismo dolor de siempre.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-185" data-mp="1622jjsdxdnfz">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-186" data-mp="114kj6qdz4gjl">
              <BadgeIcon className="h-4 w-4 text-primary" data-id="element-187" data-mp="x0l48c8cdpsc" />
              {label}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-188" data-mp="3lquhrx99on9a">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-189" data-mp="3hqu2kaecg816">
            💪 QUIERO MI COMBO LUMBAR AHORA →
          </Button>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-190" data-mp="21awco6qesnfd">
          <span className="flex items-center gap-1" data-id="element-191" data-mp="269r3nvyj5iak">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-192" data-mp="267wlgpen84a6" />
            Garantía 7 días
          </span>
          <span className="text-sky-300" data-id="element-193" data-mp="2fzsu2uecvcsn">·</span>
          <span className="flex items-center gap-1" data-id="element-194" data-mp="2fz0wje1774zq">
            <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-195" data-mp="2kyvn1gh29sk9" />
            Pago seguro
          </span>
          <span className="text-sky-300" data-id="element-196" data-mp="2p0h5dhcd6z1u">·</span>
          <span className="flex items-center gap-1" data-id="element-197" data-mp="2p1s8rg1we4sf">
            <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-198" data-mp="2tzbq4otw6xol" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-199" data-mp="un9bbrw7qrh9">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-sky-100 bg-white p-4 text-center shadow-sm" data-id="element-200" data-mp="zm2lpbg7e2d7">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-201" data-mp="3vi6xmil2u6sm">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-202" data-mp="e9jwdqsj53qb">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}